import React from "react";
import { useSelector } from "react-redux";
import Barcode from "react-barcode";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const CuponPDFAfiliados = React.forwardRef((props, ref) => {
  const { infoConsultaAfiliado = [] } = useSelector(
    (state) => state.facturasAfiliado
  );
  const { observacion = "" } = useSelector(
    (state) => state.propuestaFacturacion
  );
  return (
    <div
      ref={ref}
      style={{
        fontFamily: "Roboto, sans-serif",
        fontSize: "1.4rem",
        margin: "0 5rem, max-width: 77rem",
      }}
    >
      <div style={{ display: "inline-block", width: "37rem" }}>
        <img
          src="https://i.postimg.cc/7PBNFnBb/LOGOS-RGB-02.png"
          alt="Ospedyc"
          style={{ maxHeight: "100%", maxWidth: "100%" }}
        />
      </div>
      <div
        style={{
          display: "inline-block",
          verticalAlign: "top",
          position: "relative",
          top: "2rem",
        }}
      >
        <p>
          ALBERTI 646 - Capital Federal
          <br />
          CUIT: 30-68833954-1 - IVA: RI -<br />
          IIBB: EXENTO - GCIAS: EXENTO RNOS: 1-106005
          <br />A CONSUMIDOR FINAL
        </p>
      </div>
      <div style={{ margin: "0.7rem 3.4rem" }}>
        <div>
          <b>NRO ORDEN DE PAGO: {props.numOrdenPago}</b>
          <span style={{ float: "right" }}>
            <b>{new Date().toLocaleString("es", optionsfecha)}</b>
          </span>
        </div>
        <div>
          <div
            style={{
              display: "inline-block",
              width: "46%",
              margin: "2rem 0",
              borderRight: "3px solid #68389f",
            }}
          >
            <b>{infoConsultaAfiliado[0]?.apellido_nombre}</b>
            <br />
            TIPO AFILIADO: {infoConsultaAfiliado[0]?.tipo_afiliacion}
            <br />
            NRO AFILIADO: {infoConsultaAfiliado[0]?.carnet}
            <br />
            PERIODO FACTURADO: {infoConsultaAfiliado[0]?.periodo}
            <br />
            VENCIMIENTO:{" "}
            {new Date(infoConsultaAfiliado[0]?.fechaVencimiento).toLocaleString(
              "es",
              optionsfecha
            )}
            <br />
            <br />
            DEUDA ANTERIOR: $ {infoConsultaAfiliado[0]?.deuda}
            <br />
            <br />
            {infoConsultaAfiliado[0]?.grupoFamiliar > 0
              ? `CANTIDAD FAMILIARES: ${infoConsultaAfiliado[0]?.grupoFamiliar}`
              : ""}
          </div>
          <div
            style={{
              margin: "2rem 0",
              display: "inline-block",
              width: "41%",
              paddingLeft: "7rem",
              verticalAlign: "top",
              lineHeight: "4rem",
              position: "relative",
              top: "2rem",
            }}
          >
            IMPORTE CUOTA: $ {infoConsultaAfiliado[0]?.importeCapital}
            <br />
            INTERESES: $ {infoConsultaAfiliado[0]?.importeInteres}
            <br />
            <b>TOTAL A PAGAR: $ {infoConsultaAfiliado[0]?.total}</b>
            <br />
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          padding: "2rem 0",
          borderBottom: "3px solid #68389f",
        }}
      >
        TALON PARA EL AFILIADO
      </div>
      <div style={{ margin: "2.7rem 3.4rem" }}>
        <div style={{ width: "80%" }}>
          <b>PERIODO FACTURADO: {infoConsultaAfiliado[0]?.periodo}</b>
          <span style={{ float: "right" }}>
            <b>{infoConsultaAfiliado[0]?.apellido_nombre}</b>
          </span>
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
        }}
      >
        <Barcode value={infoConsultaAfiliado[0]?.barra} />
      </div>
      <div
        style={{
          textAlign: "center",
          padding: "2rem 0",
          borderBottom: "3px solid #68389f",
        }}
      >
        TALON PARA PAGO FACIL
      </div>
      <textarea rows={8}
        style={{
          border: "2px solid black",
          margin: "2rem",
          resize: "none",
          minWidth: "65rem",
          fontSize: "1.7rem",
        }}
      >
        {observacion?.descripcion ?? ""}
      </textarea>
    </div>
  );
});